export default "__VITE_ASSET__Ceeo47Ao__"